import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vignetteStylesheetsEdit_template } from "../components/templates/vignetteStylesheetsEdit_template";

declare var ko: any;
declare var page: any;

export class vignette_stylesheets_edit extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: vignetteStylesheetsEdit_template;
    protected XHRHdlCaller: string;

    protected getModuleName() {
        return 'vignette_stylesheets_edit';
    }

    buildContent(): Array<Element> {
        this.editForm = new vignetteStylesheetsEdit_template('editForm', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignette Stylesheet Edit');

        return [this.editForm.build()];
    }

    public fillPage(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.editForm.setBrand(idBrand);
        }

        this.editForm.setupMonacoEditors();
        this.getFormData();
    }

    protected getFormData() {
        let idStylesheet = this.getVnAppZone().getApp().params.id;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        if (!idStylesheet || !idBrand) {
            return;
        }

        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = `/api/brand/${idBrand}/vignette-stylesheets/get/${idStylesheet}`;
        let usrReq_params: Array<Array<string>> = [];
        let vm: any = this.editForm.getViewModelForRequest();
        vm.lockItem = true;
        usrReq_params.push(["data", ko.toJSON(vm)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {
        return () => {
            try {
                obj.manageResponse(req, obj, () => {
                    const responseParsed = JSON.parse(req.request.response).data;
                    if (responseParsed.stylesheet) {
                        obj.editForm.setStylesheet(responseParsed.stylesheet);
                        if (!obj.editForm.getIsBrandOwner()) {
                            obj.cancel();
                            return;
                        }
                    }
                    obj.editForm.setPermissions(responseParsed.permissions);
                });
            } catch (e) {
                console.error(e);
            } finally {
                obj.loadingOut(obj.editForm.builtTemplate);
            }
        }
    }

    public isBrand(): boolean {
        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public saveStylesheet(actionSource: string = 'save') {
        this.validationTemplate.clearMessages();

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        let cssContent = subViewModel.css || "";

        if (cssContent) {
            cssContent = cssContent.replace(/<\/?style\b[^>]*>/gi, "").trim();
            this.editForm.getTemplateViewModel().css(cssContent);
            subViewModel.css = cssContent;
        }

        this.loadingIn(this.editForm.builtTemplate);
        this.XHRHdlCaller = actionSource;

        let formReq_url: string = `/api/brand/${this.getBrandId()}/vignette-stylesheets/save/`;
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(['data', ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveStylesheetReturn;
        XHRHdl.execute();
    }

    protected onSaveStylesheetReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.id) {
                    obj.editForm.setId(responseParsed.data.id);
                    obj.updateRouteAfterStylesheetId(responseParsed.data.id, obj.XHRHdlCaller);
                }
                if (responseParsed.data && typeof responseParsed.data.idStatus !== 'undefined') {
                    obj.editForm.setIdStatus(responseParsed.data.idStatus);
                }

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Vignette stylesheet saved successfully!');
                if (obj.XHRHdlCaller !== 'stay') {
                    obj.releaseLock('save');
                }
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected updateRouteAfterStylesheetId(idStylesheet: number, actionSource: string): void {
        if (!idStylesheet || !window.location.pathname.includes('/categorization/vignette-stylesheets/add')) {
            return;
        }

        if (actionSource === 'stay') {
            window.history.pushState(
                'vignette-stylesheet-edit',
                'Emaki CMS',
                `/brand/${this.getBrandId()}/categorization/vignette-stylesheets/edit/${idStylesheet}`
            );
        }
    }

    protected releaseLock(actionSource: string) {
        let idStylesheet = this.getVnAppZone().getApp().params.id || this.editForm.getId();
        let url: string = `/api/brand/${this.getBrandId()}/vignette-stylesheets/release/${idStylesheet}`;

        this.XHRHdlCaller = actionSource;
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPostRequestReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onPostRequestReleaseLockReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if (obj.XHRHdlCaller === 'save' || obj.XHRHdlCaller === 'cancel') {
                    obj.cancel();
                }
            });
        }
    }

    public cancel() {
        page(`/brand/${this.getBrandId()}/categorization/vignette-stylesheets`);
    }

    public getBrandId() {
        return this.getVnAppZone().getApp().params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignette_stylesheets_edit.ts